export const columnNames = ['caseId', 'agencyCode', 'caseType', 'public', 'status', 'poster', 'openDate', 'missingDate', 'country', 'state', 'city', 'address', 'circumstances', 'lastSeen', 'miscellaneous', 'personId', 'personType', 'portraitURL', 'alternateURL', 'progressedURL', 'fullName', 'age', 'birthDate', 'sex', 'weight', 'weightUnit', 'height', 'heightUnit', 'eyeColor', 'hairColor', 'companionType'];
export interface ICaseRow {
  caseId: string;
  agencyCode: string;
  caseType: string;
  public: boolean;
  status: string;
  poster: string;
  openDate: string;
  missingDate: string;
  country: string;
  state: string;
  city: string;
  address: string;
  circumstances: string;
  lastSeen: string;
  miscellaneous: string;
  personId: string;
  personType: string;
  portraitURL: string;
  alternateURL: string;
  progressedURL: string;
  fullName: string;
  age: number;
  birthDate: string;
  sex: string;
  weight: string;
  weightUnit: string;
  height: string;
  heightUnit: string;
  eyeColor: string;
  hairColor: string;
  companionType: string;
}



// WEBPACK FOOTER //
// ./src/share/types/case/caseUpload.ts